import { FC } from 'react';
import { useSelector } from 'react-redux';

import { H3, SideMenuLink, Spinner } from '@portal/common/components';
import { styled } from '@portal/common/theme';

import _ from '../../../locale';
import { MY_FAVORITES_ID, MY_PERMALINK_ID } from '../../../router/paths';
import {
    getCustomLists,
    getFavoriteResources,
    getPermalinkResources,
} from '../../../store/resource-lists/selectors';
import EditResourceListModal from '../../EditResourceListModal';
import ListItem from './ListItem';
import ListsMenu from './ListsMenu';

const StyledSpinner = styled(Spinner)({
    marginLeft: 10,
});

const Header = styled('div')(({ theme }) => ({
    color: theme.color.white,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    padding: '8px 0 16px',
}));

const List = styled('div')({
    display: 'flex',
    flexFlow: 'column nowrap',
    '> *': {
        flexShrink: 0,
    },
});

const myFavoritesList = {
    name: _('default_list_name'),
    id: MY_FAVORITES_ID,
};

const myPermalinkList = {
    name: _('share_permalink_nav_link_label'),
    id: MY_PERMALINK_ID,
};

const MyListsMenu: FC = () => {
    const myLists = useSelector(getCustomLists);
    const favoriteResources = useSelector(getFavoriteResources);
    const permalinkResources = useSelector(getPermalinkResources);

    const favoriteResourcesCount = favoriteResources?.length;
    const permalinkResourcesCount = permalinkResources?.length;

    return (
        <>
            <Header>
                <H3>{_('lists_my_lists_header')}</H3>
                {myLists == null && <StyledSpinner />}
            </Header>
            <List>
                <ListItem list={myFavoritesList} resourceCount={favoriteResourcesCount} />
                <ListItem list={myPermalinkList} resourceCount={permalinkResourcesCount} />
                {myLists != null && <ListsMenu items={myLists} />}
                <EditResourceListModal>
                    {({ openModal }) => (
                        <SideMenuLink onClick={openModal}>{_('lists_add_new')}</SideMenuLink>
                    )}
                </EditResourceListModal>
            </List>
        </>
    );
};

export default MyListsMenu;
